package com.nonopn.skydome.common.app.pages.main.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

import com.nonopn.icons.SkipNext
import com.nonopn.icons.SkipPrevious
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.pages.main.model.FakeMainScreenModel
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import com.nonopn.skywatcher.design.widgets.DatePickerDialog
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import com.nonopn.skywatcher.design.widgets.endOfDay

import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.CustomOutlinedButton
import eu.codlab.compose.widgets.TextNormal
import korlibs.time.DateFormat

@Composable
fun MapDateSelection(
    modifier: Modifier,
    model: MainScreenModel
) {
    var showDateSelection by remember { mutableStateOf(false) }

    val color = defaultCardBackground()
    val state by model.states.collectAsState()
    val isRangeMode = state.selectedDateRangeStart != null

    if (showDateSelection) {
        DatePickerDialog(
            defaultDate = state.selectedDate,
            defaultRangeStart = state.selectedDateRangeStart,
            initialRangeMode = isRangeMode,
            onDismiss = { showDateSelection = false },
            onDate = {
                model.setSelectedDate(it.endOfDay)
                showDateSelection = false
            },
            onRange = { from, to ->
                model.setSelectedDateRange(from, to)
                showDateSelection = false
            }
        )
    }

    DefaultCard(
        modifier = modifier,
        backgroundColor = color,
        columnModifier = Modifier
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Column(Modifier.weight(1.0f)) { }

            if (!isRangeMode) {
                MapOverlayButtonInCard(
                    modifier = Modifier.width(24.dp).height(24.dp),
                    imageVector = Icons.Default.SkipPrevious,
                    contentDescription = "Previous"
                ) {
                    model.previousSelectedDateDay()
                }
            }

            CustomOutlinedButton(
                onClick = { showDateSelection = true }
            ) {
                if (isRangeMode && state.selectedDateRangeStart != null) {
                    val rangeFormat = DateFormat("dd/MM/yyyy")
                    val fromLabel = state.selectedDateRangeStart!!.format(rangeFormat)
                    val toLabel = state.selectedDate.format(rangeFormat)
                    TextNormal("$fromLabel → $toLabel")
                } else {
                    TextNormal(
                        state.selectedDate.format(DateFormat.FORMAT_DATE)
                    )
                }
            }

            if (!isRangeMode) {
                MapOverlayButtonInCard(
                    modifier = Modifier.width(24.dp).height(24.dp),
                    imageVector = Icons.Default.SkipNext,
                    contentDescription = "Next"
                ) {
                    model.nextSelectedDateDay()
                }
            }

            Column(Modifier.weight(1.0f)) { }
        }
    }
}

@Composable
@HotPreview(widthDp = 250, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 250, heightDp = 50, darkMode = false)
private fun MapDateSelection() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        MapDateSelection(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(false)
        )
    }
}
